module.exports = __webpack_public_path__ + "fonts/SamsungOne-700v10.16896a4b.woff";